import { render } from "./PageBarraAviso.vue?vue&type=template&id=289713b6&scoped=true"
import script from "./PageBarraAviso.vue?vue&type=script&lang=js"
export * from "./PageBarraAviso.vue?vue&type=script&lang=js"

import "./PageBarraAviso.vue?vue&type=style&index=0&id=289713b6&scoped=true&lang=css"

import exportComponent from "C:\\Users\\LAF\\Desktop\\GARANTEPAY\\PROJETOS\\WORKFLOW\\FrontVue-main\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-289713b6"]])

export default __exports__